import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy,
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import * as HSET from "./settings";
import { WidgetConfig } from "../../../class/widget-config";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from "@angular/router";
addMore(Highcharts);
@Component({
  selector: 'widget-simple-column-chart',
  templateUrl: './widget-simple-column-chart.component.html',
  styleUrls: ['./widget-simple-column-chart.component.scss']
})
export class WidgetSimpleColumnChartComponent implements OnInit, OnDestroy, OnChanges {
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  loadingChart = false;
  errorLoadingChart = false;
  message = '';
  private unsubscribe: Subject<void> = new Subject();

  
  constructor(
    private dataService: DataService,
    private router: Router
  ) {}

  

  ngOnChanges(changes: SimpleChanges) {
      this.getData();
      this.message = this.router.url.includes('inventory') ? 'WAREHOUSE.HIGHLIGHT_INVENTORY_MSG' : '';
  }

  ngOnInit() {
  }

  getData() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;
    this.dataService.getData(this.WIDGETCONFIG.api, this.WIDGETCONFIG, this.FILTERS)
    .pipe(takeUntil(this.unsubscribe)).subscribe(
      chartData => {
        this.loadingChart = false;
        if (chartData) {
          this.chartOptions = this.dataService.createChart(
            chartData,
            this.CHARTCONFIG
          );
        } else {
          this.handleError("ERROR_MSG.NO_DATA");
        }
      },
      error => {
        this.loadingChart = false;
        this.handleError("ERROR_MSG.SYSTEM_ERROR");
      }
    );
  }

  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: this.CHARTCONFIG[0], width: 12 }];

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
